import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';
import { ApiHelper } from '@sc/pas-common';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class AutoPlanDownloadsService {

    constructor(private api: ApiHelper) {
    }

    download(url = '', fileName = 'doc.pdf', type = 'application/pdf', overrideHeaders = {}) {

        return new Observable(observer => {

            const defaultHeaders = {
                'Content-Type': 'application/stream',
                'x-authorization': localStorage.getItem('tk'),
                'x-branchOffice': localStorage.getItem('branchOffice')
            };

            const requestHeaders = { ...defaultHeaders, ...overrideHeaders };

            this.api.getWithoutResponse(url, null, requestHeaders, 'blob')
                .subscribe((file: any) => {
                    const headers = new HttpHeaders();
                    const headerFileName = headers['x-filename'];

                    const linkElement = document.createElement('a');
                    try {
                        const blob = new Blob([file], { type: type });
                        const urlLink = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', urlLink);
                        linkElement.setAttribute('download', headerFileName || fileName);

                        const clickEvent = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        observer.error(ex);
                        observer.complete();
                    }
                    observer.next(true);
                    observer.complete();
                },
                    error => {
                        observer.error(error);
                        observer.complete();
                    })
        })

    }

    downloadPolicyChange(jobNumber: string, branchOffice: number) {
        const _url = `${environment.server.api.car}/api/Reports/policyChange?JobNumber=${jobNumber}`;
        return this.download(_url, `Endoso_${jobNumber}`, 'application/pdf', { 'x-branchOffice': branchOffice });
    }

    downloadHomePolicy(casa, ramo, nroPoliza) {
        const _url = `${environment.server.api.cS}/CrossSellingPolicy/GetEmittedPolicyAsync/${casa}/${ramo}/${nroPoliza}`;

        return this.download(_url, `FrentePoliza_${casa}_${ramo}_${nroPoliza}`);
    }

    downloadPolicy(branchOffice, branch, policyNumber) {

        let _url = environment.server.api.car + '/api/Reports/policyWithoutClauses/';
        _url += branchOffice + '/';
        _url += branch + '/';
        _url += policyNumber + '/';
        _url += '1';

        const fileName = this.getFileName('Frente_de_Poliza_sin_Clausulas_', branchOffice, branch, policyNumber);

        return this.download(_url, fileName, 'application/pdf', { 'x-branchOffice': branchOffice.toString() });

    }

    downloadMandatoryInsurance(branchOffice, branch, policyNumber) {

        let _url = environment.server.api.car + '/api/Reports/mandatoryInsurance/';
        _url += branchOffice + '/';
        _url += branch + '/';
        _url += policyNumber + '/';
        _url += '1'; // riskNumber

        const fileName = this.getFileName('Tarjeta_de_Seguro_obligatorio_', branchOffice, branch, policyNumber);

        return this.download(_url, fileName, 'application/pdf', { 'x-branchOffice': branchOffice.toString() });
    }

    downloadCertificate(branchOffice, branch, policyNumber, certificateNumber) {

        let _url = environment.server.api.car + '/api/Reports/certificate?';
        _url += 'BranchOffice=' + branchOffice + '&';
        _url += 'Branch=' + branch + '&';

        if (policyNumber && policyNumber !== '' && !certificateNumber) {
            _url += 'PolicyNumber=' + policyNumber + '&';
        }
        if (certificateNumber && certificateNumber !== '') {
            _url += 'CertificateNumber=' + certificateNumber + '&';
        }

        _url += 'RiskNumber=' + '1'; // riskNumber

        return this.download(_url, 'Descargar certificado', 'application/pdf', { 'x-branchOffice': branchOffice.toString() });

    }

    downloadProofOfPayment(branchOffice, branch, policyNumber) {

        let _url = environment.server.api.car + '/api/Reports/receiptCarPaymentReport/';
        _url += branchOffice + '/';
        _url += branch + '/';
        _url += policyNumber + '/';
        _url += '1'; // riskNumber

        return this.download(_url, 'Descargar Comprobante de Pago', 'application/pdf', { 'x-branchOffice': branchOffice.toString() });

    }

    downloadCoupons(branchOffice, branch, policyNumber) {

        let _url = environment.server.api.car + '/api/Reports/couponsReport/';
        _url += branchOffice + '/';
        _url += branch + '/';
        _url += policyNumber;

        const fileName = this.getFileName('Cupon_', branchOffice, branch, policyNumber);

        return this.download(_url, fileName, 'application/pdf', { 'x-branchOffice': branchOffice.toString() });

    }

    downloadProposal(jobNumber) {
        let _url = environment.server.api.car + '/api/Reports/proposal/';
        _url += jobNumber;
        return this.download(_url, 'Descargar propuesta');
    }

    downloadMercosur(branchOffice, branch, policyNumber) {

        let _url = environment.server.api.car + '/api/Reports/mercosurCertificate/';
        _url += branchOffice + '/';
        _url += branch + '/';
        _url += policyNumber + '/';
        _url += '1'; // riskNumber

        const fileName = this.getFileName('Certificado_Mercosur_', branchOffice, branch, policyNumber);

        return this.download(_url, fileName, 'application/pdf', { 'x-branchOffice': branchOffice.toString() });
    }

    downloadMercosurForCertificate(branchOffice: number, certificateNumber: string) {

        const _url = environment.server.api.car + '/api/Reports/mercosurCertificate/' + certificateNumber;
        const fileName = 'Certificado_Mercosur_' + certificateNumber;

        return this.download(_url, fileName, 'application/pdf', { 'x-branchOffice': branchOffice.toString() });
    }

    downloadPolicyWithClauses(branchOffice, branch, policyNumber) {
        let _url = environment.server.api.car + '/api/Reports/policyWithClauses/';
        _url += branchOffice + '/';
        _url += branch + '/';
        _url += policyNumber + '/';
        _url += '1';

        const fileName = this.getFileName('Frente_de_poliza_con_clausulas_', branchOffice, branch, policyNumber);

        return this.download(_url, fileName, 'application/pdf', { 'x-branchOffice': branchOffice.toString() });
    }

    downloadPolicyChangeRePrint(policyNumber) {
        const endpoint = `${environment.server.api.car}/api/Reports/planPolicyChange?policyNumber=${policyNumber}`;
        const fileName = `Endoso_re_facturacion_${policyNumber}`;

        return this.download(endpoint, fileName, 'application/pdf');
    }

    getFileName(fileNameStartName, branchOffice, branch, policyNumber) {
        let fileName = fileNameStartName;
        fileName += branchOffice + '/';
        fileName += branch + '/';
        fileName += policyNumber + '/';

        return fileName;
    }

}
